var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke-linejoin:round;stroke-width:0.4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.3,15.256H4.829v-.8A1.927,1.927,0,0,1,6.16,12.635L3.383,4.344a1.7,1.7,0,0,0-1.447-.856H.2V2.953L1.936,2.9A2.284,2.284,0,0,1,3.9,4.184L6.97,13.116H6.565a1.28,1.28,0,0,0-1.157,1.337v.267H19.3ZM6.276,19a1.341,1.341,0,1,1,0-2.674,1.341,1.341,0,1,1,0,2.674Zm0-2.14a.858.858,0,0,0-.868.8.821.821,0,0,0,.868.8.821.821,0,0,0,.868-.8.858.858,0,0,0-.868-.8ZM17.849,19A1.341,1.341,0,1,1,19.3,17.663,1.382,1.382,0,0,1,17.849,19Zm0-2.14a.8.8,0,1,0,.868.8.858.858,0,0,0-.868-.8Zm.81-3.744H6.565v-.535H18.2l1.91-6.953H4.251V5.093H20.8Z",
    transform: "translate(0 -2.7)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.abc678e884395bb5704ac1bd5aa444bf.svg";
export { ForwardRef as ReactComponent };